import { Container } from 'react-bootstrap';
import { AppShell } from '../../components/AppShell/AppShell';
import { Footer } from '../../components/Footer/Footer';
import { Title } from '../../components/Title/Title';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { useCurrentLanguage } from '../../../hooks/useCurrentLanguage';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import styles from './Categorie.module.scss';

const Categorie = () => {
  const { seriesTags } = useFirebase();
  const { currentLanguage } = useCurrentLanguage();
  const { t } = useTranslation();
  const [missingImages, setMissingImages] = useState<Set<string>>(new Set());
  const categories = seriesTags
    .filter(({ tagVideos }) => tagVideos?.length)
    .sort((a, b) => a.tag.label.localeCompare(b.tag.label, currentLanguage));

  return (
    <AppShell>
      <div className="d-flex flex-column flex-grow-1">
        <Title>{t('categorie.labels.titolo')}</Title>
        <Container className="flex-grow-1">
          <h1 className="text-page-title text-center">{t('categorie.labels.titolo')}</h1>
          <p className="text-page-subtitle text-center pb-4">{t('categorie.labels.sottotitolo')}</p>
          <div>
            {categories.map(({ tag }) => (
              <div className={`${styles.categoryCard} surface-card mb-2`} key={tag.id}>
                {!!tag.image && !missingImages.has(tag.id) && (
                  <div
                    className={styles.categoryImage}
                    style={{ backgroundImage: `url(${tag.image})` }}
                  />
                )}
                <Link className={styles.categoryTitle} to={`/categorie/${tag.id}`}>{tag.label}</Link>
              </div>
            ))}
          </div>
        </Container>
        <Footer />
      </div>
    </AppShell>
  );
};

export default Categorie;
